module.exports = __webpack_public_path__ + "static/img/img-2.141547b8.png";